React = require 'react'
t = require('views/internal/recup-with-helpers')('member_list_item_detail')

module.exports = class OrganizationMembersItemComponent extends React.Component

  render: t.renderable ->
    { isVirtual, isDeactivated, fullName, username, showGoogleApps, gMail, boardCount, isOrgMember, showActivity, allowTypeChange, orgMemberType, allowReactivate, isMe, canRemove, orgIsBC, ownsOrg, hidden, onViewActivity, onViewBoards, onRoleChange, onRemoveOrDeactivate, avatarHash, avatarDomain, initials, isOrganizationAdmin, onReactivateClick, onUnhideMember, onHideMember, onInviteMember, onAddToTeam } = @props

    t.div { class: t.classify('member-list-item-detail': true) },  ->
      t.div { class: t.classify('member': true,  'member-no-menu': true, 'member-virtual': isVirtual, 'member-deactivated': isDeactivated) }, ->
          if avatarHash
            t.img '.member-avatar', {
              height: '30',
              width: '30',
              src: [avatarDomain, avatarHash, '30.png'].join('/')
              srcSet: [avatarDomain, avatarHash, '30.png 1x'].join('/') + ', ' + [avatarDomain, avatarHash, '50.png 2x'].join('/')
              alt: fullName + " (" + username + ")",
              title: fullName + " (" + username + ")"
            }

          else
            t.span '.member-initials', { title: fullName + " (" + username + ")" }, ->
              if initials
                t.text initials

          if !isDeactivated
            if isOrganizationAdmin
              t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

          t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }

      t.div '.details', ->

        t.p '.name-line', ->
          t.span '.full-name', ->
            if fullName
              t.text fullName

        t.p '.u-bottom.quiet', ->
          if username
            t.span '.quiet.u-inline-block', ->
              t.format 'at-username', { username: username }

          if showGoogleApps
            if gMail
              if username
                t.text "- "
              t.icon 'google'
              t.text gMail

      t.div '.options', ->
        if showActivity
          t.b onViewActivity, '.option.quiet-button', ->
            t.format 'on-boardcount', { boardCount: boardCount }

        if isOrgMember
          if allowTypeChange
            t.b onRoleChange, '.option.button-link.role-button', ->
              t.text orgMemberType
              t.icon 'dropdown-menu'
          else
            t.p '.option.status.quiet', ->
              t.text orgMemberType

          if allowReactivate
            t.b onReactivateClick, '.option.quiet-button', ->
              t.format 'reactivate'

          if isMe
            t.b onRemoveOrDeactivate, { class: t.classify('option': true, 'button-link': true, 'remove-button': true, 'disabled': !canRemove), disabled: !canRemove }, ->
              if orgIsBC
                t.icon 'close', 'leave-ellipsis'
              else
                t.icon 'close', 'leave'

          else
            if ownsOrg
              t.b onRemoveOrDeactivate, { class: t.classify('option': true, 'button-link': true, 'remove-button': true, 'disabled': !canRemove), disabled: !canRemove }, ->
                t.icon 'close', 'remove-ellipsis'

        else if showGoogleApps
            if hidden
              t.b onUnhideMember, '.option.quiet-button', ->
                t.format 'always-show'
            else
              t.b onHideMember, '.option.quiet-button', ->
                t.format 'dismiss'

            t.b onInviteMember, '.option.button-link.primary', ->
              t.icon 'add', 'add-member'

        else if allowTypeChange
          t.b onAddToTeam, '.option.button-link', ->
            t.format 'add-to-team'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-item-component.coffee